export default __webpack_public_path__ + "static/media/mail.28967c78.svg";